$(function() {



    window.setTimeout(function(){
        $('.u-hidden-at-first').removeClass('u-hidden-at-first');
    }, 100);


});
